import Vue from "vue";

export function httpGetBanner(data) {
  return Vue.$axios({
    url: "/api/wealth/main/banner",
    method: "post",
    data,
  });
}

export function httpGetHot(data) {
  return Vue.$axios({
    url: "/api/wealth/main/hot",
    method: "post",
    data,
  });
}

export function httpGetDetial(data) {
  return Vue.$axios({
    url: "/api/wealth/main/detial",
    method: "post",
    data,
  });
}

export function httpOrder(data) {
  return Vue.$axios({
    url: "/api/wealth/main/order",
    method: "post",
    data,
  });
}

export function httpRedeem(data) {
  return Vue.$axios({
    url: "/api/wealth/main/redeem",
    method: "post",
    data,
  });
}

// 根据类型获取产品列表
export function httpGetLists(data) {
  return Vue.$axios({
    url: "/api/wealth/main/lists",
    method: "post",
    data,
  });
}

export function httpGetMywealth(data) {
  return Vue.$axios({
    url: "/api/wealth/main/currency",
    method: "post",
    data,
  });
}

export function httpGetLog(data) {
  return Vue.$axios({
    url: "/api/wealth/main/log",
    method: "post",
    data,
  });
}
